import React from 'react'

import { Icon } from '@app/components/util'
import { ICON_SIZE } from '@app/constants'
import { ICON_NAME } from '@app/constants/icon'

import styles from './styles.module.scss'

export const WarningContent: React.FC<{ text?: string }> = ({ text }) => {
  if (!text) return <></>

  return (
    <span className={ styles.warningContent }>
      <Icon
        name={ ICON_NAME.warningYellow }
        size={ ICON_SIZE }
      />
      { text }
    </span>
  )
}
